import { useTranslation } from "react-i18next";
import { checkResponseStatus } from "@/lib/utils/responseChecker";

/**
 * Hook that provides a response checker with translation support
 * @param context - Optional context for error translations
 * @returns Object with checkResponse function and translation function
 */
export const useResponseChecker = (context?: string) => {
  const { t } = useTranslation(["errors"]);

  const checkResponse = (
    response: Response,
    customErrors?: Record<number, string>
  ) => {
    checkResponseStatus(response, t, { context, customErrors });
  };

  return { checkResponse, t };
};

/**
 * Hook that creates a pre-configured response checker for a specific context
 * @param context - The context for error translations
 * @returns A function that checks response status with the given context
 */
export const useContextResponseChecker = (context: string) => {
  const { t } = useTranslation(["errors"]);

  return (response: Response, customErrors?: Record<number, string>) => {
    checkResponseStatus(response, t, { context, customErrors });
  };
};
